import { ModifyNewPromptLibraryItemDialog } from "@/modules/promptLibrary/components/modifyNewPromptLibraryItemDialog";
import { usePromptLibraryContext } from "@/modules/promptLibrary/usePromptLibraryContext";

/** "Add to library" dialog opened from chat messages through the prompt library context. */
export const CreatePromptLibraryItemDialog = () => {
  const { createPromptLibraryModalState, closeCreatePromptLibraryModal } = usePromptLibraryContext();

  if (!createPromptLibraryModalState) return null;

  return (
    <ModifyNewPromptLibraryItemDialog
      mode="add"
      isOpen
      setIsOpen={closeCreatePromptLibraryModal}
      item={{
        prompt: createPromptLibraryModalState.prompt,
        source: createPromptLibraryModalState.source,
      }}
    />
  );
};
